module.exports = __webpack_public_path__ + "static/media/honey-chipotle-chicken-dumpling.3de2305c.png";